import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.handleEscape = this.closeOnEscape.bind(this)
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.handleEscape)
    this.overlayTarget.scrollTop = 0
  }

  openAt(event) {
    const index = event.currentTarget.dataset.galleryOverlayIndexParam
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.handleEscape)

    const photo = this.overlayTarget.querySelector(`[data-photo-index="${index}"]`)
    if (photo) {
      requestAnimationFrame(() => {
        photo.scrollIntoView({ behavior: "instant", block: "start" })
      })
    }
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.handleEscape)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}
